// extracted by mini-css-extract-plugin
module.exports = {"modal":"typeform-modal_modal__F3R36","typeform":"typeform-modal_typeform__AVRNO","close":"typeform-modal_close__3IUrO"};